window.RES_COUNTRIES = {
  COUNTRY_NAME_TO_DIAL: {
      "Afghanistan":"+93",
      "Albania":"+355",
      "Algeria":"+213",
      "Andorra":"+376",
      "Angola":"+244",
      "Anguilla":"+1",
      "Antigua and Barbuda":"+1",
      "Argentina":"+54",
      "Armenia":"+374",
      "Aruba":"+297",
      "Australia":"+61",
      "Austria":"+43",
      "Azerbaijan":"+994",
      "Bahamas":"+1",
      "Bahrain":"+973",
      "Bangladesh":"+880",
      "Barbados":"+1",
      "Belarus":"+375",
      "Belgium":"+32",
      "Belize":"+501",
      "Benin":"+229",
      "Bermuda":"+1",
      "Bhutan":"+975",
      "Bolivia":"+591",
      "Bosnia and Herzegovina":"+387",
      "Botswana":"+267",
      "Brazil":"+55",
      "British Virgin Islands":"+1",
      "Brunei":"+673",
      "Bulgaria":"+359",
      "Burkina Faso":"+226",
      "Burundi":"+257",
      "Cambodia":"+855",
      "Cameroon":"+237",
      "Canada":"+1",
      "Cape Verde":"+238",
      "Cayman Islands":"+1-135",
      "Central African Republic":"+236",
      "Chad":"+235",
      "Chile":"+56",
      "China":"+86",
      "Colombia":"+57",
      "Comoros":"+269",
      "Congo":"+242",
      "Costa Rica":"+506",
      "Croatia":"+385",
      "Cuba":"+53",
      "Cyprus":"+357",
      "Czech Republic":"+420",
      "Denmark":"+45",
      "Djibouti":"+253",
      "Dominica":"+1",
      "Dominican Republic":"+1",
      "Ecuador":"+593",
      "Egypt":"+20",
      "El Salvador":"+503",
      "Equatorial Guinea":"+240",
      "Eritrea":"+291",
      "Estonia":"+372",
      "Eswatini":"+268",
      "Ethiopia":"+251",
      "Faroe Islands":"+298",
      "Fiji":"+679",
      "Finland":"+358",
      "France":"+33",
      "French Guiana":"+594",
      "French Polynesia":"+689",
      "Gabon":"+241",
      "Gambia":"+220",
      "Georgia":"+995",
      "Germany":"+49",
      "Ghana":"+233",
      "Gibraltar":"+350",
      "Greece":"+30",
      "Greenland":"+299",
      "Grenada":"+1",
      "Guadeloupe":"+590",
      "Guam":"+1",
      "Guatemala":"+502",
      "Guinea":"+224",
      "Guinea-Bissau":"+245",
      "Guyana":"+592",
      "Haiti":"+509",
      "Honduras":"+504",
      "Hong Kong":"+852",
      "Hungary":"+36",
      "Iceland":"+354",
      "India":"+91",
      "Indonesia":"+62",
      "Iran":"+98",
      "Iraq":"+964",
      "Ireland":"+353",
      "Isle of Man":"+44",
      "Israel":"+972",
      "Italy":"+39",
      "Ivory Coast":"+225",
      "Jamaica":"+1",
      "Japan":"+81",
      "Jordan":"+962",
      "Kazakhstan":"+7",
      "Kenya":"+254",
      "Kuwait":"+965",
      "Kyrgyzstan":"+996",
      "Laos":"+856",
      "Latvia":"+371",
      "Lebanon":"+961",
      "Lesotho":"+266",
      "Liberia":"+231",
      "Libya":"+218",
      "Liechtenstein":"+423",
      "Lithuania":"+370",
      "Luxembourg":"+352",
      "Macao":"+853",
      "Madagascar":"+261",
      "Malawi":"+265",
      "Malaysia":"+60",
      "Maldives":"+960",
      "Mali":"+223",
      "Malta":"+356",
      "Marshall Islands":"+692",
      "Martinique":"+596",
      "Mauritania":"+222",
      "Mauritius":"+230",
      "Mayotte":"+262",
      "Mexico":"+52",
      "Micronesia":"+691",
      "Moldova":"+373",
      "Monaco":"+377",
      "Mongolia":"+976",
      "Montenegro":"+382",
      "Montserrat":"+1",
      "Morocco":"+212",
      "Mozambique":"+258",
      "Myanmar":"+95",
      "Namibia":"+264",
      "Nepal":"+977",
      "Netherlands":"+31",
      "New Caledonia":"+687",
      "New Zealand":"+64",
      "Nicaragua":"+505",
      "Niger":"+227",
      "Nigeria":"+234",
      "North Korea":"+850",
      "North Macedonia":"+389",
      "Northern Mariana Islands":"+1",
      "Norway":"+47",
      "Oman":"+968",
      "Pakistan":"+92",
      "Palau":"+680",
      "Palestine":"+970",
      "Panama":"+507",
      "Papua New Guinea":"+675",
      "Paraguay":"+595",
      "Peru":"+51",
      "Philippines":"+63",
      "Poland":"+48",
      "Portugal":"+351",
      "Puerto Rico":"+1",
      "Qatar":"+974",
      "Reunion":"+262",
      "Romania":"+40",
      "Russia":"+7",
      "Rwanda":"+250",
      "Saint Kitts and Nevis":"+1",
      "Saint Lucia":"+1",
      "Saint Vincent and the Grenadines":"+1",
      "Samoa":"+685",
      "San Marino":"+378",
      "Sao Tome and Principe":"+239",
      "Saudi Arabia":"+966",
      "Senegal":"+221",
      "Serbia":"+381",
      "Seychelles":"+248",
      "Sierra Leone":"+232",
      "Singapore":"+65",
      "Slovakia":"+421",
      "Slovenia":"+386",
      "Solomon Islands":"+677",
      "Somalia":"+252",
      "South Africa":"+27",
      "South Korea":"+82",
      "South Sudan":"+211",
      "Spain":"+34",
      "Sri Lanka":"+94",
      "Sudan":"+249",
      "Suriname":"+597",
      "Sweden":"+46",
      "Switzerland":"+41",
      "Syria":"+963",
      "Taiwan":"+886",
      "Tajikistan":"+992",
      "Tanzania":"+255",
      "Thailand":"+66",
      "Timor-Leste":"+670",
      "Togo":"+228",
      "Tonga":"+676",
      "Trinidad and Tobago":"+1",
      "Tunisia":"+216",
      "Turkey":"+90",
      "Turkmenistan":"+993",
      "Uganda":"+256",
      "Ukraine":"+380",
      "United Arab Emirates":"+971",
      "United Kingdom":"+44",
      "United States":"+1",
      "Uruguay":"+598",
      "Uzbekistan":"+998",
      "Vanuatu":"+678",
      "Vatican City":"+379",
      "Venezuela":"+58",
      "Vietnam":"+84",
      "Western Sahara":"+212",
      "Yemen":"+967",
      "Zambia":"+260",
      "Zimbabwe":"+263"
    },
  ISO2_TO_COUNTRY_NAME: {
      AF:"Afghanistan", AL:"Albania", DZ:"Algeria", AD:"Andorra", AO:"Angola",
      AI:"Anguilla", AG:"Antigua and Barbuda", AR:"Argentina", AM:"Armenia", AW:"Aruba",
      AU:"Australia", AT:"Austria", AZ:"Azerbaijan", BS:"Bahamas", BH:"Bahrain", BD:"Bangladesh",
      BB:"Barbados", BY:"Belarus", BE:"Belgium", BZ:"Belize", BJ:"Benin", BM:"Bermuda", BT:"Bhutan",
      BO:"Bolivia", BA:"Bosnia and Herzegovina", BW:"Botswana", BR:"Brazil", VG:"British Virgin Islands",
      BN:"Brunei", BG:"Bulgaria", BF:"Burkina Faso", BI:"Burundi", KH:"Cambodia", CM:"Cameroon", CA:"Canada",
      CV:"Cape Verde", KY:"Cayman Islands", CF:"Central African Republic", TD:"Chad", CL:"Chile", CN:"China",
      CO:"Colombia", KM:"Comoros", CG:"Congo",
      CR:"Costa Rica", HR:"Croatia", CU:"Cuba", CY:"Cyprus", CZ:"Czech Republic", DK:"Denmark", DJ:"Djibouti",
      DM:"Dominica", DO:"Dominican Republic", EC:"Ecuador", EG:"Egypt", SV:"El Salvador", GQ:"Equatorial Guinea",
      ER:"Eritrea", EE:"Estonia", SZ:"Eswatini", ET:"Ethiopia", FO:"Faroe Islands",
      FJ:"Fiji", FI:"Finland", FR:"France", GF:"French Guiana", PF:"French Polynesia", GA:"Gabon", GM:"Gambia",
      GE:"Georgia", DE:"Germany", GH:"Ghana", GI:"Gibraltar", GR:"Greece", GL:"Greenland", GD:"Grenada",
      GP:"Guadeloupe", GU:"Guam", GT:"Guatemala", GN:"Guinea", GW:"Guinea-Bissau", GY:"Guyana", HT:"Haiti",
      HN:"Honduras", HK:"Hong Kong", HU:"Hungary", IS:"Iceland", IN:"India", ID:"Indonesia", IR:"Iran", IQ:"Iraq",
      IE:"Ireland", IM:"Isle of Man", IL:"Israel", IT:"Italy", CI:"Ivory Coast", JM:"Jamaica", JP:"Japan", JO:"Jordan",
      KZ:"Kazakhstan", KE:"Kenya", KW:"Kuwait", KG:"Kyrgyzstan", LA:"Laos", LV:"Latvia", LB:"Lebanon",
      LS:"Lesotho", LR:"Liberia", LY:"Libya", LI:"Liechtenstein", LT:"Lithuania", LU:"Luxembourg", MO:"Macao",
      MG:"Madagascar", MW:"Malawi", MY:"Malaysia", MV:"Maldives", ML:"Mali", MT:"Malta", MH:"Marshall Islands",
      MQ:"Martinique", MR:"Mauritania", MU:"Mauritius", YT:"Mayotte", MX:"Mexico", FM:"Micronesia", MD:"Moldova",
      MC:"Monaco", MN:"Mongolia", ME:"Montenegro", MS:"Montserrat", MA:"Morocco", MZ:"Mozambique", MM:"Myanmar",
      NA:"Namibia", NP:"Nepal", NL:"Netherlands", NC:"New Caledonia", NZ:"New Zealand", NI:"Nicaragua",
      NE:"Niger", NG:"Nigeria", KP:"North Korea", MK:"North Macedonia",
      MP:"Northern Mariana Islands", NO:"Norway", OM:"Oman", PK:"Pakistan", PW:"Palau", PS:"Palestine", PA:"Panama",
      PG:"Papua New Guinea", PY:"Paraguay", PE:"Peru", PH:"Philippines", PL:"Poland", PT:"Portugal",
      PR:"Puerto Rico", QA:"Qatar", RE:"Reunion", RO:"Romania", RU:"Russia", RW:"Rwanda", KN:"Saint Kitts and Nevis",
      LC:"Saint Lucia", VC:"Saint Vincent and the Grenadines", WS:"Samoa", SM:"San Marino",
      ST:"Sao Tome and Principe", SA:"Saudi Arabia", SN:"Senegal", RS:"Serbia", SC:"Seychelles", SL:"Sierra Leone",
      SG:"Singapore", SK:"Slovakia", SI:"Slovenia", SB:"Solomon Islands", SO:"Somalia", ZA:"South Africa", KR:"South Korea",
      SS:"South Sudan", ES:"Spain", LK:"Sri Lanka", SD:"Sudan", SR:"Suriname", SE:"Sweden", CH:"Switzerland", SY:"Syria",
      TW:"Taiwan", TJ:"Tajikistan", TZ:"Tanzania", TH:"Thailand", TL:"Timor-Leste", TG:"Togo", TO:"Tonga",
      TT:"Trinidad and Tobago", TN:"Tunisia", TR:"Turkey", TM:"Turkmenistan", UG:"Uganda", UA:"Ukraine",
      AE:"United Arab Emirates", GB:"United Kingdom", US:"United States", UY:"Uruguay", UZ:"Uzbekistan", VU:"Vanuatu",
      VA:"Vatican City", VE:"Venezuela", VN:"Vietnam", EH:"Western Sahara", YE:"Yemen",
      ZM:"Zambia", ZW:"Zimbabwe"
    }
};